import { usePathname } from 'next/navigation'
import { Routes } from '@scalis/routes'
import {
  Divider,
  SearchProspectsIcon,
  AiSourcingAgentIcon,
  TalentPoolsIcon,
  SequencesIcon,
  CampaignsIcon,
} from '~/scalis-components/core'
import { Aside } from '../aside'

interface ATSProps {
  showContent: boolean
}

export const CRM = ({ showContent }: ATSProps) => {
  const pathname = usePathname()
  return (
    <>
      <Aside.List>
        {showContent && <span className='body-small-basic text-neutral-secondary pl-1'>CRM</span>}
        <Aside.Item
          label='Search Prospects'
          href={Routes.crm.search_prospects}
          icon={SearchProspectsIcon}
          active={pathname?.includes(Routes.crm.search_prospects)}
          showContent={showContent}
        />
        <Aside.Item
          label='AI Sourcing Agent'
          href={Routes.crm.ai_sourcing_agent}
          icon={AiSourcingAgentIcon}
          active={pathname?.includes(Routes.crm.ai_sourcing_agent)}
          showContent={showContent}
        />
        <Aside.Item
          label='Talent Pools'
          href={Routes.crm.talent_pools}
          icon={TalentPoolsIcon}
          active={pathname?.includes(Routes.crm.talent_pools)}
          showContent={showContent}
        />
        <Aside.Item
          label='Sequences'
          href={Routes.crm.sequences}
          icon={SequencesIcon}
          active={pathname?.includes(Routes.crm.sequences)}
          showContent={showContent}
        />
        <Aside.Item
          label='Campaigns'
          href={Routes.crm.campaigns}
          icon={CampaignsIcon}
          active={pathname?.includes(Routes.crm.campaigns)}
          showContent={showContent}
        />
      </Aside.List>
      <Divider />
    </>
  )
}
